import React, { Component } from  'react';
import {
  InputGroup, Form
} from 'react-bootstrap'
import { debounce } from 'vega';

class KeyframeParamPanel extends Component {
  constructor(props){
    super(props);
    this.debouncedUpdateDuration = debounce(700, this.props.onKeyframeRecomParamChange);
    this.debouncedUpdateDataJoinKey = debounce(700, this.props.onKeyframeRecomParamChange);
  }

  render() {
    return <div className="mb-3 d-inline-flex felx-row">
      <InputGroup size="sm" className="mr-2" style={{"maxWidth": 200}}>
        <InputGroup.Prepend>
          <InputGroup.Text htmlFor="stageNSelect">
            # of Stages
          </InputGroup.Text>
        </InputGroup.Prepend>

        <Form.Control
          as="select"
          value={this.props.params.stageN}
          id="stageNSelect"
          onChange={this.onChangeStageN.bind(this)}
          style={{"maxWidth": 55}}
        >
          {
            this.props.stageNList.map(n => {
              return <option key={`stageN-${n}`}value={n}>{n}</option>
            })
          }
        </Form.Control>
      </InputGroup>

      <InputGroup size="sm" className="mr-2" style={{"maxWidth": 250}}>
        <InputGroup.Prepend>
          <InputGroup.Text htmlFor="sequenceDuration">
            Sequence Duration
          </InputGroup.Text>
        </InputGroup.Prepend>

        <Form.Control
          id="sequnceDuration"
          placeholder="Milliseconds"
          aria-label="duration"
          aria-describedby="duration"
          type="number"
          min={0}
          defaultValue={this.props.params.duration}
          onChange={this.onChangeSequenceDuration.bind(this)}
        ></Form.Control>
      </InputGroup>



      <InputGroup size="sm" className="mr-2">
        <InputGroup.Prepend>
          <InputGroup.Text htmlFor="sequenceDataJoinKey">
            Data Join By
          </InputGroup.Text>
        </InputGroup.Prepend>

        <Form.Control
          id="sequenceDataJoinKey"
          placeholder='e.g., "name; year"'
          aria-label="Sequence Data JoinKey"
          aria-describedby="Sequence Data JoinKey"
          type="text"
          defaultValue={this.props.params.dataJoinKey}
          onChange={this.onChangeDataJoinKey.bind(this)}
        ></Form.Control>
      </InputGroup>

      <InputGroup size="sm" className="mr-2" >
        <InputGroup.Prepend>
          <InputGroup.Text htmlFor="sequence-x-domain-dimension">
            X Domain Dimension
          </InputGroup.Text>
        </InputGroup.Prepend>

        <Form.Control
          as="select"
          value={this.props.params.xScaleDomainDimension || "default"}
          id="sequence-x-domain-dimension"
          onChange={this.onChangeXScaleDomainDimension.bind(this)}
          style={{"minWidth": 70}}
        >
          <option value="default">Default</option>
          <option value="diff">Change</option>
          <option value="same">UnChange</option>
        </Form.Control>
      </InputGroup>

      <InputGroup size="sm" className="mr-2" >
        <InputGroup.Prepend>
          <InputGroup.Text htmlFor="sequence-y-domain-dimension">
            Y Domain Dimension
          </InputGroup.Text>
        </InputGroup.Prepend>

        <Form.Control
          as="select"
          value={this.props.params.yScaleDomainDimension || "default"}
          id="sequence-y-domain-dimension"
          onChange={this.onChangeYScaleDomainDimension.bind(this)}
          style={{"minWidth": 70}}
        >
          <option value="default">Default</option>
          <option value="diff">Change</option>
          <option value="same">UnChange</option>
        </Form.Control>
      </InputGroup>
    </div>
  }

  onChangeStageN(event) {
    this.props.onKeyframeRecomParamChange({
      stageN: Number(event.target.value)
    });
  }
  onChangeSequenceDuration(event) {
    let dur = event.target.value*1.0;
    this.debouncedUpdateDuration({duration: dur});
  }

  onChangeDataJoinKey(event) {
    let dataJoinKey = event.target.value;
    this.debouncedUpdateDataJoinKey({dataJoinKey: dataJoinKey})
  }

  onChangeXScaleDomainDimension(event) {
    this.props.onKeyframeRecomParamChange({ xScaleDomainDimension: event.target.value })
  }

  onChangeYScaleDomainDimension(event) {
    this.props.onKeyframeRecomParamChange({ yScaleDomainDimension: event.target.value })
  }
}
export default KeyframeParamPanel;

